import i18next from "i18next";
import React from "react";
import Button from "~assets/js/components/Button";
import PropTypes from "prop-types";

const PODCAST_URL =
    "https://open.spotify.com/episode/2xwDhPs5TgK3iFbTGu5x3c?si=cykfa0VpRISAtNt8j40jpQ";

export const BottomCards = () => (
    <div className="franchise-bottom-cards">
        <div className="left">
            <Card
                className="left"
                title={i18next.t("franchise.bottomCards.left.title")}
                content={i18next.t("franchise.bottomCards.left.content")}
                button={
                    <Button
                        href="/franchise-formular"
                        size="SM"
                        variant="primary"
                        label={i18next.t("franchise.banner.hero.cta")}
                    />
                }
            />
        </div>
        <div className="right">
            <Card
                className="right"
                title={i18next.t("franchise.bottomCards.right.title")}
                content={i18next.t("franchise.bottomCards.right.content")}
                button={
                    <Button
                        href={PODCAST_URL}
                        size="SM"
                        variant="secondary"
                        label={i18next.t(
                            "franchise.bottomCards.right.buttonText"
                        )}
                    />
                }
            />
        </div>
    </div>
);

const Card = ({ className, title, content, button }) => {
    return (
        <div className="card">
            <div className={`image ${className}`}></div>
            <div className="content">
                <p className="title">{title}</p>
                <p className="content">{content}</p>
                <div className="card-button">{button}</div>
            </div>
        </div>
    );
};

Card.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    button: PropTypes.elementType,
};

export default BottomCards;
